module.exports = __webpack_public_path__ + "img/1517634694.a96fe23f.jpg";